/**
 * Converts a given string to kebab case.
 *
 * Examples:
 * - 'camelCase' -> 'camel-case'
 * - 'PascalCase' -> 'pascal-case'
 */
export const convertToKebabCase = (value) => {
    return value.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};
//# sourceMappingURL=convert-to-kebab-case.js.map